import { render, staticRenderFns } from "./Fairness.vue?vue&type=template&id=828ace92&"
import script from "./Fairness.vue?vue&type=script&lang=js&"
export * from "./Fairness.vue?vue&type=script&lang=js&"
import style0 from "./Fairness.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports